module.exports = __webpack_public_path__ + "static/media/group-small-placeholder.9ac5dee6.webp";